// 前端角色权限矩阵 —— 与服务端 server/middleware/auth.ts 的 requireRoles 白名单一一对应
// 仅用于按钮级禁用/提示（最终裁决在服务端，前端不做路由拦截）
import { getStoredUser } from '../api/client.js';

export type PermAction =
  | 'account:write'    // 科目新增/编辑/删除（REVIEW）
  | 'party:write'      // 他人/公开档案编辑停用与治理（REVIEW）
  | 'party:create'     // 自助建档与自持档案维护，建档强制挂自己为负责人（ALL_WRITE，8.4.2）
  | 'journal:create'   // 凭证录入/删除草稿（ALL_WRITE）
  | 'journal:post'     // 过账/审核/冲销/生成记账凭证（REVIEW）
  | 'wechat:confirm'   // 收款流水确认（ALL_WRITE）
  | 'import:use'       // 流水导入解析/确认（ALL_WRITE）
  | 'monitor:ingest'   // 会话消息摄入（ALL_WRITE）
  | 'signal:handle'    // 监管信号处理（REVIEW）
  | 'aging:scan'       // 账龄超期扫描 / 财务预警状态流转（REVIEW）
  | 'closing:manage';  // 结账/反结账/年结（ADMIN_ONLY）

const MATRIX: Record<PermAction, string[]> = {
  'account:write': ['admin', 'senior_accountant'],
  'party:write': ['admin', 'senior_accountant'],
  'party:create': ['admin', 'senior_accountant', 'accountant'],
  'journal:create': ['admin', 'senior_accountant', 'accountant'],
  'journal:post': ['admin', 'senior_accountant'],
  'wechat:confirm': ['admin', 'senior_accountant', 'accountant'],
  'import:use': ['admin', 'senior_accountant', 'accountant'],
  'monitor:ingest': ['admin', 'senior_accountant', 'accountant'],
  'signal:handle': ['admin', 'senior_accountant'],
  'aging:scan': ['admin', 'senior_accountant'],
  'closing:manage': ['admin'],
};

export const NO_PERM_HINT = '当前角色无权执行此操作';

/**
 * 当前登录角色是否可执行该操作。
 * 匿名（试点期未登录）返回 true —— 与后端 authMiddleware 匿名放行通道保持一致。
 */
export function roleCan(action: PermAction, role: string | null | undefined = getStoredUser()?.role): boolean {
  if (!role) return true;
  return MATRIX[action].includes(role);
}

/** 无权限时的 title 提示（有权限返回 undefined） */
export function permHint(action: PermAction): string | undefined {
  return roleCan(action) ? undefined : NO_PERM_HINT;
}
